import {
  SET_LIST_FAQ_DATA,
  SET_LIST_FAQ_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listGeneralFaqData: null,
  listGeneralFaqDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_FAQ_DATA:
      return {
        ...state,
        loading: false,
        listGeneralFaqData: action.listGeneralFaqData,
      };

    case SET_LIST_FAQ_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listGeneralFaqDataTotal: action.listGeneralFaqDataTotal,
      };

    default:
      return { ...state };
  }
};
